// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import ConditionalSubform from "../../components/ConditionalSubform";
import EditableField from "../../components/EditableField";
import * as formConditions from "../../utils/formConditions";
import * as mappers from "../../utils/mappers";
import * as v from "../../utils/validators";
import * as formatters from "../../utils/formatters";
import { errors } from "../../utils/errors";

import {
  PURPOSE_KIND,
  VEHICLE_KIND,
  VEHICLE_KIND__OTHER,
  VEHICLE_OTHER_DESCRIPTION,
  VEHICLE_YEARLY_MILEAGE,
  VEHICLE_MANUFACTURER,
  VEHICLE_MODEL,
  FEDERAL_STATE,
  VEHICLE_NEW,
  VEHICLE_COUNT,
  VEHICLE_YEAR,
  AMOUNT
} from "./formFields";
import { mapPurposeKind, getKind, mapVehicleType } from "./mappers";
import { type InvestmentSectionProps } from "../../types/details";

const InvestmentVehicles = ({
  kind,
  initialValues,
  handleSubmit,
  isLocked
}: InvestmentSectionProps) => {
  const { fieldHasValue } = formConditions;

  return (
    <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked={isLocked}>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: PURPOSE_KIND,
            caption: () => "Investitionsvorhaben"
          }}
          displayValue={value => {
            const purposeKind = getKind(value, kind);
            return purposeKind && mapPurposeKind(purposeKind.kind);
          }}
        />
        <EditableField
          fieldControlProps={{
            name: AMOUNT,
            caption: () => "Investitionsbetrag (netto)"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: FEDERAL_STATE,
            caption: () => "Investitionsort liegt in..."
          }}
        />
      </FormRow>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: VEHICLE_COUNT,
            caption: () => "Anzahl an Fahrzeugen"
          }}
        />
        <EditableField
          fieldControlProps={{
            name: VEHICLE_YEARLY_MILEAGE,
            caption: () => "Voraussichtliche Fahrleistung in km",
            validate: v.combineWithPrefillCheck(
              errors.requiredField(),
              v.upperBound(999999999, errors.maxLengthDigits(9))
            )
          }}
          inputProps={{ placeholder: "in km", sideSymbol: () => "km" }}
          displayValue={formatters.formatDistanceInKm}
          type="numberInput"
        />
        <div />
      </FormRow>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: VEHICLE_NEW,
            caption: () => "Neufahrzeug?"
          }}
          type="yesNoGroup"
          displayValue={mappers.yesNoMapper}
        />
        <ConditionalSubform
          condition={fieldHasValue(VEHICLE_NEW, false)}
          renderOnSatisfy={() => (
            <EditableField
              fieldControlProps={{
                name: VEHICLE_YEAR,
                caption: () => "Baujahr"
              }}
            />
          )}
          renderOnFail={() => <div />}
        />
        <div />
      </FormRow>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: VEHICLE_KIND,
            caption: () => "Fahrzeugtyp",
            validate: v.combineWithPrefillCheck(errors.requiredField())
          }}
          displayValue={mapVehicleType}
        />
        <ConditionalSubform
          condition={fieldHasValue(VEHICLE_KIND, VEHICLE_KIND__OTHER)}
          renderOnSatisfy={() => (
            <EditableField
              fieldControlProps={{
                name: VEHICLE_OTHER_DESCRIPTION,
                caption: () => "Beschreibung",
                validate: v.combineWithPrefillCheck(
                  errors.requiredField(),
                  v.maxLength(100, errors.maxLengthCharacters(100))
                )
              }}
            />
          )}
          renderOnFail={() => <div />}
        />
        <div />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: VEHICLE_MANUFACTURER,
            caption: () => "Hersteller"
          }}
        />
        <EditableField
          fieldControlProps={{
            name: VEHICLE_MODEL,
            caption: () => "Modell"
          }}
        />
        <div />
      </FormRow>
    </EditableForm>
  );
};

export default InvestmentVehicles;
